// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './assets/css/base.css'
import 'lib-flexible/flexible.js'
import VueI18n from 'vue-i18n'
import animated from 'animate.css'

Vue.use(animated)

Vue.use(VueI18n) // 通过插件的形式挂载

Vue.config.productionTip = false
if (process.env.NODE_ENV == 'development') {
  Vue.prototype.$modelUrl = '';
} else {
  Vue.prototype.$modelUrl = 'https://wennoanimal.com/animalGame/Lion';
  // Vue.prototype.$modelUrl = 'https://www.bunchparty.com/wennoGame';
}

var JsSrc = (navigator.language || navigator.browserLanguage).toLowerCase();
var lang;
if (JsSrc.indexOf('zh-cn') >= 0) {
  // 假如浏览器语言是中文
  lang = 'zh';
} else if (JsSrc.indexOf('zh-hk') >= 0 || JsSrc.indexOf('zh-tw') >= 0 || JsSrc.indexOf('zh-sg') >= 0 || JsSrc.indexOf('zh-mo') >= 0) {
  // 假如浏览器语言是英文
  lang = 'hk';
} else {
  // 假如浏览器语言是其它语言
  lang = 'en';
}
console.log(JsSrc);

const i18n = new VueI18n({
  locale: sessionStorage.getItem('locale') || lang, // 语言标识
  messages: {
    'zh': require('./assets/common/lang/zh'), // 中文语言包
    'en': require('./assets/common/lang/en'), // 英文语言包
    'hk': require('./assets/common/lang/hk') //中文繁体
  },
  silentTranslationWarn: true
})
//判断浏览器s
var ua = navigator.userAgent;
var isIOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
if ((ua.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
  if (ua.match(/MicroMessenger\/[0-9]/i)) {
    sessionStorage.setItem('isWebKit', '0');
    if (isIOS) {
      sessionStorage.setItem('isToBrowser', '1');
    }
  } else if (ua.match(/QQ\/[0-9]/i)) {
    if (isIOS) {
      sessionStorage.setItem('isToBrowser', '1');
    }
    sessionStorage.setItem('isWebKit', '0');
  } else if (ua.indexOf("Chrome") > -1) {
    sessionStorage.setItem('isWebKit', '1');
  } else if (ua.indexOf("Safari") > -1) {
    sessionStorage.setItem('isWebKit', '1');
  } else {
    sessionStorage.setItem('isWebKit', '0');
  }
} else {
  sessionStorage.setItem('isWebKit', '0');
}
Vue.prototype.sessionStorage = sessionStorage;
sessionStorage.actIndex ? '' : sessionStorage.setItem('actIndex', '0');


/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n, // 不要忘记
  router,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js